var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTaurus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Taurus") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Taurus",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,20 C9.791,20 8,18.209 8,16 C8,13.791 9.791,12 12,12 C14.209,12 16,13.791 16,16 C16,18.209 14.209,20 12,20 M12,10 C8.686,10 6,12.686 6,16 C6,19.314 8.686,22 12,22 C15.314,22 18,19.314 18,16 C18,12.686 15.314,10 12,10",
    id: "Head",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,3 C20,7.418 16.418,11 12,11 C7.582,11 4,7.418 4,3 L2,3 C2,7.734 5.293,11.69 9.711,12.726 C10.36,12.272 11.147,12 12,12 C12.853,12 13.64,12.272 14.289,12.726 C18.707,11.69 22,7.734 22,3 L20,3 Z",
    id: "Horns",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaurus);
export default __webpack_public_path__ + "static/media/taurus.0c19faa0620efaceaf328ef3ffad116e.svg";
export { ForwardRef as ReactComponent };